/**
 * Function that searches the Available list of item in the portal user form.
 * 
 * @param {HTMLInputElement} searchInput the HTML search input element
 * @param {HTMLElement} avalContainer the HTML container for the selected items
 */
export const searchAvailList = (searchInput: HTMLInputElement, avalContainer: HTMLElement) => {
  searchInput.addEventListener('keyup', () => {
    const filter = searchInput.value.toUpperCase();
    const a = Array.from(avalContainer.getElementsByTagName('span'));
    a.forEach((span) => {
      const txtValue = span.textContent!;
      const displayStyle = txtValue.toUpperCase().includes(filter) ? 'flex' : 'none';
      span.parentElement!.style.setProperty('display', displayStyle, 'important');
    });
  });
}